import React, { useEffect, useState } from 'react';
import Spinner from 'react-bootstrap/Spinner';
import {
  Container, Tabs, Tab, Row, Col,
} from 'react-bootstrap';
import axios from 'axios';
import Navbar from '../../../../components/Navbar';
import Header from '../../../../components/Header';
import Pengajuan from './pengajuan';
import { DaftarProgresStyle } from './style';
import { Loader } from '../../../Superadmin/TambahAdmin/styles';
import config from '../../../../config';

const DaftarProgres = () => {
  const [status, setStatus] = useState('menunggu');
  const [loading, setLoading] = useState(true);
  const [datas, setDatas] = useState([
    {
      nama: 'Seminar Gua',
      url: `PengajuanKuliahUmum/detail/${1}`,
    },
  ]);

  useEffect(() => {
    axios.get(`${config.API_BASE_URL}api/pengajuan_kuliah_umum/?status=${status}`, {
      headers: {
        accept: 'application/json',
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
    }).then(
      ({ data }) => {
        const simplifyData = data.map((
          (content) => (
            {
              nama: content.kum_id.nama_kegiatan,
              url: `detail/${content.id}`,
            }
          )
        ));
        setDatas(simplifyData);
        setLoading(false);
      },
    );
  }, [status]);

  if (loading) {
    return (
      <Loader>
        <Spinner animation="border" />
      </Loader>
    );
  }

  return (
    <>
      <Navbar />
      <Header />
      <DaftarProgresStyle>
        <Container className="container-list">
          <h1 className="text-center mb-2 font-48"><u>Proses Pengajuan Kegiatan KUM</u></h1>
          <h3 className="text-center mb-5 font-28">Status Pengajuan KUM Anda</h3>
          <Tabs
            className="w-100 mt-5"
            id="controlled-tab"
            data-testid="date"
            activeState={status}
            onSelect={(k) => setStatus(k)}
          >
            <Tab tabClassName="status-header font-24" eventKey="menunggu" title="Menunggu Persetujuan" />
            <Tab tabClassName="status-header font-24" eventKey="disetujui" title="Disetujui" />
            <Tab tabClassName="status-header font-24" eventKey="ditolak" title="Ditolak" />
            <Tab tabClassName="status-header font-24" eventKey="sukses" title="Sukses" />
          </Tabs>
          <Row className="mt-3 border-dark border-bottom ml-1 mr-1">
            <Col><p className="font-24">Nama Event</p></Col>
            <Col><p className="font-24 text-right">Detail</p></Col>
          </Row>
          <div className="mt-3">
            {datas.map((
              (data) => <Pengajuan nama={data.nama} url={data.url} />
            ))}
          </div>
        </Container>
      </DaftarProgresStyle>
    </>
  );
};

export default DaftarProgres;
